module.exports = __webpack_public_path__ + "static/img/icon-03.f882d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/icon-03.png
// module id = f1IC
// module chunks = 1